//PREPRODUCCION
// module.exports = {
//   apiKey: "AIzaSyCeZjkP237icX5T3NZLPHPClbBGF6qmSnc",
//   authDomain: "asambleageneral-314d8.firebaseapp.com",
//   databaseURL: "https://asambleageneral-314d8-default-rtdb.firebaseio.com",
//   projectId: "asambleageneral-314d8",
//   storageBucket: "gs://asambleageneral-314d8.appspot.com",
//   messagingSenderId: "5284122877",
//   appId: "1:5284122877:web:1855c4be2f141c78c3ee94",
//   measurementId: "G-77LCZ83BY2",
// };

//PRODUCCION
module.exports = {
  apiKey: "AIzaSyBeVwEcsbH3_whzEU0vRojWr99GO52l3uw",
  authDomain: "asambleageneralproduccion.firebaseapp.com",
  databaseURL: "https://asambleageneralproduccion-default-rtdb.firebaseio.com",
  projectId: "asambleageneralproduccion",
  storageBucket: "asambleageneralproduccion.firebasestorage.app",
  messagingSenderId: "367408017575",
  appId: "1:367408017575:web:f476f6917fdd3176332b82",
  measurementId: "G-BW373YS42Z"
};